import * as types from './types';

const INITIAL_STATE = {
  error: null,
  servedItems: [],
  loadingServedItems: false,
  loadingCalculation: false,
  loadingWriteMeals: false,
  writeError: null,
  writeSuccessful: false,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.WRITE_PROVISION2_MEALS_LOADING:
      return {
        ...state,
        loadingWriteMeals: payload,
      };
    case types.RESET_WRITE_ERROR:
      return {
        ...state,
        writeError: null,
      };
    case types.WRITE_PROVISION2_MEALS_ERROR:
      return {
        ...state,
        writeError: payload,
      };
    case types.RESET_WRITE_SUCCESSFUL:
      return {
        ...state,
        writeSuccessful: false,
      };
    case types.WRITE_PROVISION2_MEALS_SUCCESS:
      return {
        ...state,
        writeSuccessful: true,
      };
    case types.GET_CALCULATION_LOADING:
      return {
        ...state,
        loadingCalculation: payload,
      };
    case types.GET_SERVED_ITEMS_ERROR:
    case types.GET_CALCULATION_ERROR:
      return {
        ...state,
        error: payload,
      };
    case types.RESET_ERROR:
      return {
        ...state,
        error: null,
      };
    case types.GET_SERVED_ITEMS_LOADING:
      return {
        ...state,
        loadingServedItems: payload,
      };
    case types.GET_SERVED_ITEMS_SUCCESS:
      return {
        ...state,
        servedItems: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/provision2/state/reducer.js